module.exports = __webpack_public_path__ + "img/advance.f770e5f7.svg";